import {observable, action, runInAction} from 'mobx'
import {PAGE_SIZE_DEFAULT} from '../constants/appConstant'
import jobManagementAPI from '../apis/jobManagementAPI'
import alertMessage from '../utils/alertMessage'

export default class JobManagementStore {
  constructor(rootStore) {
    this.rootStore = rootStore
  }

  @observable isFetching = false
  @observable pageSize = PAGE_SIZE_DEFAULT
  @observable pageNo = 1
  @observable currIndex = 0
  @observable itemCount = 0
  @observable pageSizeLog = PAGE_SIZE_DEFAULT
  @observable pageNoLog = 1
  @observable currIndexLog = 0
  @observable itemCountLog = 0
  @observable inBoundNameList = []
  @observable outBoundNameList = []
  @observable batchList = []

  /*SearchResult start*/
  @observable searchItem = {
    'jobName': '',
    'jobType': null,
    'jobStatus': null,
    'page': this.pageNo,
    'size': this.pageSize,
  }
  @observable jobList = []

  @action
  async onSearchJobAction(params) {
    this.isFetching = true
    this.jobList = []
    this.pageNo = params.page
    this.pageSize = params.size
    this.itemCount = 0
    try {
      const response = await jobManagementAPI.searchAction(params)
      runInAction(() => {
        this.isFetching = false
        if (response.data.code === 0) {
          this.jobList = response.data.data?.records || []
          this.itemCount = response.data.data?.total
          this.searchItem = params
        }
      })
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }

  @action
  onChangeJob(value) {
    this.jobList = value
    this.itemCount = 0
  }

  /*SearchResult end*/
  @observable jobType = []
  @observable jobStatus = []
  @observable executeTypes = []

  @action
  async onOptionsAction() {
    this.isFetching = true
    this.jobType = []
    this.jobStatus = []
    this.executeTypes = []
    try {
      const response = await jobManagementAPI.optionsAction()
      runInAction(() => {
        this.isFetching = false
        if (response.data.code === 0) {
          this.jobType = response.data.data?.jobType
          this.jobStatus = response.data.data?.jobStatus
          this.executeTypes = response.data.data?.executeTypes
        } else {
          alertMessage.error(response.data.message)
        }
      })
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }

  /*add permission*/
  @action
  async onAddJobAction(params, title) {
    this.isFetching = true
    try {
      const response = await jobManagementAPI.addAction(params)
      runInAction(() => {
        this.isFetching = false
        if (response.data?.code === 0) {
          if (response.data?.data?.code !== 0 && response.data?.data?.code !== undefined) {
            alertMessage.error(title === 'edit' ? 'Edit Failed！' + response.data.data?.messageEn : 'Add Failed！' + response.data.data?.messageEn)
          } else {
            alertMessage.success(title === 'edit' ? 'Edit Success！' : 'Add Success！')
            this.onSearchJobAction(this.searchItem)
          }
        } else {
          alertMessage.error(title === 'edit' ? 'Edit Failed！' + response.data?.messageEn : 'Add Failed！' + response.data?.messageEn)
        }
      })
      return response
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }

  /*get edit permission*/
  @observable detailsObj = null

  @action
  async onGetJobAction(params) {
    this.isFetching = true
    try {
      const response = await jobManagementAPI.getAction(params)
      runInAction(() => {
        this.isFetching = false
        const {data} = response.data
        if (response.data.code === 0) {
          if (data.jobType === '3') {
            data.inboundCustomer = data.inboundCustomer.split(';')
            data.inboundApiConfigId = data.inboundApiConfigId.split(';')
          }
          this.detailsObj = data || null
        }
      })
      return response.data.data
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }

  /*schedule permission*/
  @action
  async onScheduleJobAction(params) {
    this.isFetching = true
    try {
      const response = await jobManagementAPI.scheduleAction(params)
      runInAction(() => {
        this.isFetching = false
        if (response.data.code === 0) {
          alertMessage.success('Schedule Success！')
          this.onSearchJobAction(this.searchItem)
        } else {
          alertMessage.error('Schedule Failed！' + response.data.messageEn + '')
        }
      })
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }

  /*delete permission*/
  @action
  async onDeleteJobAction(params) {
    this.isFetching = true
    try {
      const response = await jobManagementAPI.deleteAction(params)
      runInAction(() => {
        this.isFetching = false
        if (response.data.code === 0) {
          alertMessage.success('Delete Success！')
          this.onSearchJobAction({
            'jobName': '',
            'jobType': null,
            'jobStatus': null,
            'page': 1,
            'size': PAGE_SIZE_DEFAULT,
          })
        } else {
          alertMessage.error('Delete Failed！' + response.data.messageEn + '')
        }
      })
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }

  @action
  onChangePageNumAction(pageNo, pageSize) {
    if (this.pageNo === pageNo && (!pageSize || this.pageSize === pageSize)) {
      return
    }
    runInAction(() => {
      this.pageNo = pageNo
      this.pageSize = pageSize
    })
    this.onSearchJobAction({
      'jobName': this.searchItem.jobName,
      'jobType': this.searchItem.jobType,
      'jobStatus': this.searchItem.jobStatus,
      'page': pageNo,
      'size': pageSize,
    })
  }

  /*log start*/
  @observable logList = []
  @observable searchItemLog = {
    'jobId': '',
    'page': this.pageNoLog,
    'size': this.pageSizeLog,
  }

  @action
  async onDetailsJobAction(params) {
    this.isFetching = true
    this.pageNoLog = params.page
    this.pageSizeLog = params.size
    this.itemCountLog = 0
    try {
      const response = await jobManagementAPI.detailsAction(params)
      runInAction(() => {
        this.isFetching = false
        if (response.data.code === 0) {
          for (let i = 0; i < response.data.data?.list.length; i++) {
            response.data.data.list[i].messageIds = response.data.data?.list[i]?.messageIds?.replace('[', '')?.replace(']', '')
          }
          this.logList = response.data.data?.list || null
          this.itemCountLog = response.data.data?.total
          this.searchItemLog = params
        }
      })
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }

  @action
  onChangePageLogAction(pageNo, pageSize) {
    if (this.pageNoLog === pageNo && (!pageSize || this.pageSizeLog === pageSize)) {
      return
    }
    runInAction(() => {
      this.pageNoLog = pageNo
      this.pageSizeLog = pageSize
    })
    this.onDetailsJobAction({
      'jobId': this.searchItemLog.jobId,
      'page': pageNo,
      'size': pageSize,
    })
  }

  @action
  async getNameDropdown(directionType, id) {
    try {
      const response = await jobManagementAPI.getNameDropdown(directionType, id)
      runInAction(() => {
        this.isFetching = false
        if (response.data.code === 0) {
          if (directionType === 'INBOUND') {
            this.inBoundNameList = response.data.data
          } else {
            this.outBoundNameList = response.data.data
          }
        }
      })
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }

  @action
  async getBatchDetail(batchId) {
    try {
      const response = await jobManagementAPI.getBatchDetail(batchId)
      runInAction(() => {
        this.isFetching = false
        if (response.data.code === 0) {
          this.batchList = response.data.data
        }
      })
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }
}
